<template>
  <!-- 管网GIS系统-水表管理-终端用户水表 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">
                  {{ item.tenantName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="16">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择">
              <a-tree-select :tree-data="zoneTreeData" v-model="query.zoneId" style="width: 100%"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
                :treeDefaultExpandedKeys="treeDefaultExpandedKeys" show-search treeNodeFilterProp="title"
                @change="handleZoneChange"></a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="16">
            <a-form-item label="分类编码">
              <a-input v-model="query.classNo" placeholder="请输入分类编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="16">
            <a-form-item label="通信编号">
              <a-input v-model="query.commNumber" placeholder="请输入通信编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="16">
            <a-form-item label="水表编号">
              <a-input v-model="query.appearanceNo" placeholder="请输入水表编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="16">
            <a-form-item label="用户编码">
              <a-input v-model="query.userNo" placeholder="请输入用户编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="16">
            <a-form-item label="手机号码">
              <a-input v-model="query.phone" placeholder="请输入手机号码" allow-clear />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="16">
            <a-form-item label="用户名称">
              <a-input v-model="query.userNikeName" placeholder="请输入用户名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="16">
            <a-form-item label="表册号">
              <a-input v-model="query.bookName" placeholder="请输入表册号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="16">
            <a-form-item label="创建时间">
              <a-range-picker style="width: 100%" v-model="createTimeRange" valueFormat="YYYY-MM-DD HH:mm:ss"
                show-time
                @change="handleCreateTimeChange" />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="delRow()" v-action:del>删除</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="downloadTemplate({ execlForm: true })"
                v-action:upload>下载模板</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandleIdList()" :loading="exportLoading"
                v-action:export>导出</a-button>
              <a-button type="primary" style="margin-left: 8px" :loading="importLoading" @click="importHandle"
                v-action:import>
                <a-icon type="upload" />导入
              </a-button>
              <a-button type="primary" icon="hdd" style="margin-left: 8px" @click="recycleBinVisible = true"
                v-action:recycle>回收站</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="clear" v-action:clear>一键清空数据</a-button>
              <!-- 默认不给用户开放 -->
              <!-- <a-button type="primary" style="margin-left: 8px" :loading="blockLoading" @click="blockAllocation()"
                v-action:del>片区匹配</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table size="middle" rowKey="id" bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange" :scroll="{ x: 2500 }">
      <a-tag color="blue" slot="bookName" slot-scope="text">{{ bookObj[text] }}</a-tag>

      <a-tag color="blue" slot="waterBigStatus" slot-scope="text">{{ text === 1 ? '用水大户' : '普通用户' }}</a-tag>
      <a-tag color="blue" slot="waterType" slot-scope="text">
        {{ text === 0 ? '居民用水' : text === 1 ? '非居民用水' : text === 2 ? '特种用水' : text === 3 ? '混合用水' : '--' }}
      </a-tag>
      <span slot="createTime" slot-scope="text">{{ text | moment }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal title="操作" style="top: 20px" :width="800" :maskClosable="false" v-model="addOrUpdateVisible" @ok="handleOk"
      @cancel="handleCancel">
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户名称">
          <a-input placeholder="请输入用户名称" v-decorator="['userNikeName']" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户地址">
          <a-input placeholder="请输入用户地址" v-decorator="['address']" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="管理分表户数">
          <a-input-number placeholder="请输入管理分表户数"
            v-decorator="['householdCount', { rules: [{ required: false, message: '请输入管理分表户数' }] }]" :min="1"
            style="width: 100%" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用水性质">
          <a-select placeholder="请选择用水性质"
            v-decorator="['waterType', { rules: [{ required: false, message: '请选择用水性质' }] }]">
            <a-select-option :value="0">居民用水</a-select-option>
            <a-select-option :value="1">非居民用水</a-select-option>
            <a-select-option :value="2">特种用水</a-select-option>
            <a-select-option :value="3">混合用水</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系方式">
          <a-input placeholder="请输入联系方式" v-decorator="[
            'phone',
            {
              rules: [{ pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码' }],
            },
          ]" :maxLength="11" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装时间">
          <a-date-picker style="width: 100%" v-decorator="['installDate']" format="YYYY-MM-DD" placeholder="请选择安装时间" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类编码" hasFeedback>
          <a-input placeholder="分类编码" v-decorator="['classNo']" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="通信编号" hasFeedback>
          <!-- :disabled="this.isUpdate" -->
          <a-input placeholder="请输入通信编号" v-decorator="['commNumber']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="表册号" hasFeedback>
          <a-input placeholder="请输入表册号" v-decorator="['bookName']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户编码" hasFeedback>
          <a-input :disabled="this.isUpdate" v-decorator="['userNo']" placeholder="用户编码" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水表编号" hasFeedback>
          <a-input placeholder="水表编号"
            v-decorator="['appearanceNo', { rules: [{ required: true, message: '水表编号' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水表状态" hasFeedback>
          <a-input placeholder="水表状态" v-decorator="['status', { rules: [{ required: true, message: '请输入水表状态' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="口径" hasFeedback>
          <a-input placeholder="口径" v-decorator="['caliber', { rules: [{ required: true, message: '请输入口径' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="品牌" hasFeedback>
          <a-input placeholder="品牌" v-decorator="['brand', { rules: [{ required: true, message: '请输入品牌' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="类型" hasFeedback>
          <a-input placeholder="类型" v-decorator="['type', { rules: [{ required: true, message: '请输入类型' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择">
          <a-tree-select :tree-data="zoneTreeData"
            v-decorator="['zoneId', { rules: [{ required: false, message: '请选择片区' }] }]" style="width: 100%"
            :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
            tree-default-expand-all></a-tree-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <RecycleBinModal :visible.sync="recycleBinVisible" :bookObj="bookObj" @ok="modalFormOk"></RecycleBinModal>
    <importModal ref="importModal" :tree-data="zoneTreeData"
      exportUrl="/pipe-network/gis_class_user_water_meters/new/import" @close="close" @reLoad="queryList"></importModal>
    <history-modal ref="historyModal"></history-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import HistoryModal from '../module/waterHistoryModal'
import importModal from '@/views/pipenetwork/module/ImportModal'
import RecycleBinModal from '../module/WaterMeterRecycleBinModal'
import moment from 'moment'

const STATUS = { 1: '正常', 2: '禁用' }
const columns = [
  {
    title: '片区名称',
    dataIndex: 'zoneName',
    fixed: 'left',
    width: 150
  },
  {
    title: '品牌',
    dataIndex: 'brand',
  },
  {
    title: '用户编码',
    dataIndex: 'userNo',
  },
  {
    title: '分类编码',
    dataIndex: 'classNo',
  },
  {
    title: '水表编号',
    dataIndex: 'appearanceNo',
  },
  {
    title: '用户名称',
    dataIndex: 'userNikeName',
  },
  {
    title: '通信编号',
    dataIndex: 'commNumber',
  },
  {
    title: '用户地址',
    dataIndex: 'address',
  },
  {
    title: '手机号',
    dataIndex: 'phone',
  },
  {
    title: '口径',
    dataIndex: 'caliber',
  },
  {
    title: '用水性质',
    dataIndex: 'waterType',
    scopedSlots: { customRender: 'waterType' },
  },
  {
    title: '安装时间',
    dataIndex: 'installDate',
  },
  {
    title: '管理分表户数',
    dataIndex: 'householdCount',
  },
  {
    title: '表册号',
    dataIndex: 'bookName',
  },
  {
    title: '类型',
    dataIndex: 'type',
  },
  {
    title: '状态',
    dataIndex: 'status',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
  },
  {
    title: '用户用水类型',
    dataIndex: 'waterBigStatus',
    scopedSlots: { customRender: 'waterBigStatus' },
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    fixed: 'right',
    width: 100
  },
]
export default {
  components: {
    importModal,
    HistoryModal,
    RecycleBinModal,
  },
  mixins: [mixinViewModule],
  name: 'GisClassUserWaterMeter',
  data () {
    return {
      needQuery: true,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100', '1000', '5000'],
      },
      importLoading: false,
      blockLoading: false,
      recycleBinVisible: false, // 回收站操作
      downloadTemplateUrl: 'pipe-network/gis_class_user_water_meters/template/new/download', // 水表模板
      downloadTemplateName: '新分类编码用户水表导入模板.xlsx',
      fileList: [],
      queryUrl: 'pipe-network/gis_class_user_water_meters/page',
      addOrUpdateUrl: 'pipe-network/gis_class_user_water_meters',
      deleteUrl: 'pipe-network/gis_class_user_water_meters',
      queryOneUrl: 'pipe-network/gis_class_user_water_meters',
      exportDataUrl: 'pipe-network/gis_class_user_water_meters/export',
      blockAllocationUrl: 'pipe-network/gis_class_user_water_meters/block/allocation',
      bookObj: {},
      bookTreeData: [], // 表册列表
      queryBookDateUrl: 'pipe-network/meter_reading_books/list',
      // queryUrl: '/pipe-network/meter_reading_user_water/page',
      // addOrUpdateUrl: '/pipe-network/meter_reading_user_water',
      // deleteUrl: 'pipe-network/meter_reading_user_water',
      // queryOneUrl: 'pipe-network/meter_reading_user_water',
      // exportDataUrl: 'pipe-network/meter_reading_user_water/export',
      exportFileName: '新分类编码用户水表.xlsx',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      downloadUrl: 'pipe-network/gis_class_user_water_meters/export',
      zoneTreeData: [], // 分区数据选项
      treeDefaultExpandedKeys: [], // 片区选项展开
      selectedZoneName: '', // 选中的片区名称
      query: {
        sysType: true,
        zoneId: '',
        classNo: '',
        commNumber: '',
        appearanceNo: '',
        userNo: '',
        userNikeName: '',
        phone: '',
        tenantId: this.$store.state.user.info.tenantId,
        waterBigStatus: '',
        bookName: '',
        createTimeStart: '',
        createTimeEnd: '',
      },
      createTimeRange: [],
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
    }
  },
  filters: {
    statusFilter (key) {
      return STATUS[key]
    },
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
  },
  created () {
    this.getZoneData()
    this.getAllTenant()
    this.resetList()
    this.getBookData()
  },
  methods: {
    getBookData () {
      this.$http.get(this.queryBookDateUrl).then(({ data }) => {
        this.bookTreeData = data
        this.bookObj = {}
        data.forEach((element) => {
          this.bookObj[`${element.id}`] = element.name
        })
      })
    },
    delRow () {
      console.log(this.selectedRows)
      console.log(this.selectedRowKeys)
      this.deleteSelectRow()
    },
    resetList () {
      this.createTimeRange = []
      this.query = {
        sysType: true,
        zoneId: '',
        classNo: '',
        commNumber: '',
        appearanceNo: '',
        userNo: '',
        userNikeName: '',
        phone: '',
        tenantId: this.$store.state.user.info.tenantId,
        waterBigStatus: '',
        bookName: '',
        createTimeStart: '',
        createTimeEnd: '',
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.selectedRowKeys = []
      this.queryList()
    },
    handleCreateTimeChange (dates) {
      this.query.createTimeStart = dates && dates[0] ? dates[0] : ''
      this.query.createTimeEnd = dates && dates[1] ? dates[1] : ''
    },
    handleOk (e) {
      console.log('handleOk')
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          // 处理日期格式
          if (values.installDate) {
            values.installDate = values.installDate.format('YYYY-MM-DD')
          }

          const params = {
            id: this.currentId,
            ...values,
          }

          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    // 处理片区选择变化
    handleZoneChange (value, label, extra) {
      console.log('选择的片区:', value, label, extra)
      if (value) {
        // 从树形数据中查找选中的片区名称
        this.selectedZoneName = this.findZoneNameById(this.zoneTreeData, value)
      } else {
        this.selectedZoneName = ''
      }
      console.log('选中的片区名称:', this.selectedZoneName)
    },
    // 递归查找片区名称
    findZoneNameById (treeData, id) {
      for (const node of treeData) {
        if (node.id === id) {
          return node.zoneName
        }
        if (node.children && node.children.length > 0) {
          const result = this.findZoneNameById(node.children, id)
          if (result) return result
        }
      }
      return null
    },
    historyData () {
      this.$refs.historyModal.show()
    },
    // 关闭选择分区页面时
    close (val) {
      console.log(val)
      this.zoneId = val
      this.openSelectFile = true
    },
    importHandle () {
      console.log('导入按钮')
      this.$refs.importModal.show()
    },
    /**
     * 片区匹配
     * 匹配最小片区
     */
    blockAllocation () {
      this.blockLoading = true
      this.axios({
        method: 'post',
        url: this.blockAllocationUrl,
        headers: {},
        params: {},
      })
        .then((response) => {
          if (response.code === 0) {
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.blockLoading = false
        })
    },
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.currentId = id || null
      this.isUpdate = !!this.currentId
      this.addOrUpdateForm.resetFields()
      if (this.currentId) {
        this.$http.get(`${this.queryOneUrl}/${this.currentId}`).then(({ data }) => {
          // 处理日期格式
          if (data.installDate) {
            data.installDate = moment(data.installDate)
          }
          this.addOrUpdateForm.setFieldsValue(data)
        })
      }
    },
    clear () {
      this.$confirm({
        title: '清空数据',
        content: `您确定要清空所有数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.delete('/pipe-network/gis_class_user_water_meters/select/delete', {
            data: this.query
          }).then((res) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.queryList()
            }
          })
        }
      })
    },
    modalFormOk () {
      this.queryList()
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

/deep/ .ant-card-body {
  height: auto;
}

/deep/ .ant-table-body {
  height: 100% !important;
}
</style>
